import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataStudiosGallery: {
    status: "idle",
    error: null,
    data: [],
  },
};

const dataPlaceSlice = createSlice({
  name: "dataPlace",
  initialState,
  reducers: {
    getDataStudiosGalleryPending: (state) => {
      state.dataStudiosGallery.status = "pending";
      state.dataStudiosGallery.error = null;
    },
    getDataStudiosGalleryFulfilled: (state, action) => {
      state.dataStudiosGallery.status = "fulfilled";
      state.dataStudiosGallery.data = action.payload;
    },
    getDataStudiosGalleryRejected: (state, action) => {
      state.dataStudiosGallery.status = "rejected";
      state.dataStudiosGallery.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logout", () => initialState);
  },
});

export const dataPlaceActions = dataPlaceSlice.actions;

const _selectDataStudiosGallery = (state) => state.dataPlace.dataStudiosGallery;

export const selectDataStudiosGallery = createSelector(
  [(state) => _selectDataStudiosGallery(state)],
  (dataStudiosGallery) => {
    const data = dataStudiosGallery.data;
    const error = dataStudiosGallery.error;
    const status = dataStudiosGallery.status;
    const isLoading = status === "pending";
    return { data, error, status, isLoading };
  }
);

export default dataPlaceSlice.reducer;
